module.exports = __webpack_public_path__ + "static/media/zhajinhua_pc_game.075bac8.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameVideo/zhajinhua_pc_game.mp4
// module id = 3hqR
// module chunks = 0